// extracted by mini-css-extract-plugin
module.exports = {"container":"jobTitlePopover_container__3Ajm5","listIem":"jobTitlePopover_listIem__3p-PZ","inactive":"jobTitlePopover_inactive__eehjq"};